import React from 'react'

import styled from 'styled-components';

const ProfileContainer = styled.div`
  flex: 6;
  margin-top: 70px;
`;

const Notifications = () => {
  return (
    <ProfileContainer>
    <div>Notifications</div>
      </ProfileContainer>
  )
}

export default Notifications